import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { loading, user, membership, accessError, signOut } = useAuth();

  if (loading) return <div className="center-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;

  if (!membership) {
    return (
      <div className="center-screen">
        <div className="auth-card">
          <h1>Access not provisioned</h1>
          <p>{accessError || 'This account is not assigned to an active CRM workspace.'}</p>
          <button className="secondary-button" onClick={signOut}>Sign out</button>
        </div>
      </div>
    );
  }

  return children;
}
